import React, { useState, useRef, useEffect } from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import HubIndustryTile from '../HubIndustryTile';
import { TEN_INDUSTRY_TILES_MOBILE_HEIGHT } from './constants';
import './style.scss';

const DesignsByIndustry = ({ desingsTiles, onTileClick, titlePrefix, industriesPrefix }) => {
    const [isOpenedIndustries, setIsOpenedIndustries] = useState();
    const [industryWrapperMobileHeight, setIndustryWrapperMobileHeight] = useState(TEN_INDUSTRY_TILES_MOBILE_HEIGHT);
    const industriesWrapper = useRef();

    const toggleIsOpenedIndustries = () => {
        setIsOpenedIndustries(!isOpenedIndustries);
    };

    useEffect(() => {
        setIndustryWrapperMobileHeight(industriesWrapper.current.scrollHeight);
    }, []);

    return (
        <div className="design-by-industry">
            <div className="container">
                <h2 className="section-title">
                    <I18n k={titlePrefix} />
                </h2>
                <div
                    className="industries-wrapper"
                    ref={industriesWrapper}
                    style={{
                        maxHeight: isOpenedIndustries ? industryWrapperMobileHeight : TEN_INDUSTRY_TILES_MOBILE_HEIGHT,
                    }}
                >
                    {desingsTiles.map(({ title, link, imgUrl }) => (
                        <HubIndustryTile
                            key={title}
                            onClick={() => onTileClick(title)}
                            title={title}
                            link={link}
                            imgUrl={imgUrl}
                            i18nPrefix={industriesPrefix}
                        />
                    ))}
                </div>
                <button className="show-more-btn" onClick={toggleIsOpenedIndustries}>
                    <I18n k={`logo_maker_perseus.general.${isOpenedIndustries ? 'show_less' : 'show_more'}`} />
                </button>
            </div>
        </div>
    );
};

DesignsByIndustry.propTypes = {
    desingsTiles: arrayOf(
        shape({
            title: string,
            link: string,
            imgUrl: string,
        })
    ),
    onTileClick: func,
    titlePrefix: string,
    industriesPrefix: string,
};

export default DesignsByIndustry;
